import React, { useEffect, useState } from "react";
import Commentary from "./Commentary";
import { loadStyles } from "../../../utils/cssLoader";

const CommentaryWrap = ({ data, id, loadCSS, dataClient, baseUrl, title }) => {
  const [commentaryData, setCommentaryData] = useState([]);

  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const dataAttr = container?.getAttribute("data-listingdata");

    if (dataAttr) {
      try {
        const parsed = JSON.parse(dataAttr);
        setCommentaryData(parsed?.data || []);
      } catch (e) {
        console.error("Failed to parse data-listingdata:", e);
      }
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("matchtable");
    }
  }, [loadCSS]);

  const commentary = dataClient ? commentaryData : data || [];

  return (
    <Commentary data={commentary} id={id} baseUrl={baseUrl} title={title} />
  );
};

export default CommentaryWrap;
